import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Autocomplete, Typography, Checkbox,
    CircularProgress
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { selectCloths, selectItemAvg, selectItems, selectlocationdata, selectRack } from '../Selectors/Master/ItemSelectors';
import { fetchClothData } from '../../Store/PHPSlice/Cloth';
import { getCurrentDate } from '../../Utils/Dateutils';
import { fetchRackData } from '../../Store/PHPSlice/Rack';
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../NavigationContext';
import { fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import { fetchStkReturnBarcode, insertManualStkEntry } from '../../Store/PHPSlice/Stock/StockApis';
import { selectStkBarcode } from '../Selectors/StitchSelector/StitchingSelectors';
import Preview from '@mui/icons-material/Preview';
import DeleteIcon from '@mui/icons-material/Delete';
import { fetchLocationData } from '../../Store/PHPSlice/Transport';
import Dropdown from '../FieldsComponents/Dropdown';



const StkManuallyEntry2 = (props) => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        barcode: '',
        itemId: '',
        itemNm: '',
        clothId: '',
        m1cloth: '',
        m2cloth: '',
        m3cloth: '',
        qty: '',
        size: '',
        rate: '',
        rack: '',
        locId: '',
        bailno: '',
        color: '',
        shadeNo: '',
        userId: userdata?.ID
    });
    const [errors, setErrors] = useState({});
    const [number, setNumber] = useState('');
    const [numbers, setNumbers] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [clothdata, setClothdata] = useState([]);
    const [m1clothdata, setM1Clothdata] = useState([]);
    const [m2clothdata, setM2Clothdata] = useState([]);
    const [m3clothdata, setM3Clothdata] = useState([]);

    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const { setPreviousPath } = useNavigation();
    const dispatch = useDispatch();
    const itemList = useSelector(selectItems);
    const clothlist = useSelector(selectCloths);
    const rackList = useSelector(selectRack);
    const itemAvg = useSelector(selectItemAvg);
    const stkbarcode = useSelector(selectStkBarcode);
    const locData = useSelector(selectlocationdata);
    // ✅ New state for barcode tracking
    const [currentBarcode, setCurrentBarcode] = useState();

    const [multipleItems, setMultipleItems] = useState([]);
    const isDesktop = useMediaQuery('(min-width:768px)'); // Adjust the breakpoint as per your requirement

    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchClothData());
        dispatch(fetchRackData());
        dispatch(fetchItemAvgData());
        dispatch(fetchStkReturnBarcode());
        dispatch(fetchLocationData());
    }, [dispatch]);

    useEffect(() => {
        if (stkbarcode?.data?.barcode) {
            const bar = parseFloat(stkbarcode?.data?.barcode);
            setCurrentBarcode(bar);
        }
    }, [stkbarcode]);

    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            dt: e.target.value
        });
    };
    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        // Update form data with the selected dropdown value
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        switch (dropdownType) {
            case 'itemId':
                if (value) {
                    // Filter and process average values
                    const selectPanna = itemAvg.data.filter(val => val.itemId === value);
                    const selectAvg = selectPanna.filter(val => val.avg !== '0');
                    const selectm1Avg = selectPanna.filter(val => val.avg1 !== '0');
                    const selectm2Avg = selectPanna.filter(val => val.avg2 !== '0');
                    const selectm3Avg = selectPanna.filter(val => val.avg3 !== '0');

                    // Determine unique sizes
                    const uniquePannasizes = [...new Set(selectAvg.map(val => val.panna_size))];
                    const uniqueM1Pannasizes = [...new Set(selectm1Avg.map(val => val.panna_size))];
                    const uniqueM2Pannasizes = [...new Set(selectm2Avg.map(val => val.panna_size))];
                    const uniqueM3Pannasizes = [...new Set(selectm3Avg.map(val => val.panna_size))];

                    // Filter cloth data based on sizes
                    const filterCloth = clothlist.data.filter(val => uniquePannasizes.includes(val.panna_size));
                    const filterM1Cloth = clothlist.data.filter(val => uniqueM1Pannasizes.includes(val.panna_size));
                    const filterM2Cloth = clothlist.data.filter(val => uniqueM2Pannasizes.includes(val.panna_size));
                    const filterM3Cloth = clothlist.data.filter(val => uniqueM3Pannasizes.includes(val.panna_size));

                    // Update cloth data
                    setClothdata(filterCloth);
                    setM1Clothdata(filterM1Cloth);
                    setM2Clothdata(filterM2Cloth);
                    setM3Clothdata(filterM3Cloth);

                    // Update matching options
                    const newMatching = [];
                    if (filterM1Cloth.length > 0) newMatching.push({ label: 'Matching 1', value: '1' });
                    if (filterM2Cloth.length > 0) newMatching.push({ label: 'Matching 2', value: '2' });
                    if (filterM3Cloth.length > 0) newMatching.push({ label: 'Matching 3', value: '3' });

                };
                break;
            default:
                break;
        }

    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };


    const handleAddNumber = () => {

        if (formData.itemId.trim() === "") {
            alert("Please Select Item.");
            return;
        }

        if (formData.clothId.trim() === "") {
            alert("Please Select Main Cloth.");
            return;
        }

        if (number !== '') {
            const rangePattern = /^(\d+)-(\d+)$/;
            const match = number.match(rangePattern);

            const rangePattern2 = /^(\d+)-/;
            const match2 = number.match(rangePattern2);

            // ✅ Start barcode from last entry if available
            // let barcode = tableData.length > 0
            //     ? parseFloat(tableData[tableData.length - 1].barcode) + 1
            //     : parseFloat(stkbarcode?.data?.barcode || 1); // Default fallback
            let barcode = currentBarcode;
            let color = formData.color;
            let shadeNo = formData.shadeNo;

            if (match) {
                const start = parseInt(match[1], 10);
                const end = parseInt(match[2], 10);

                if (start <= end) {
                    // Create an array of numbers from start to end with a difference of 2
                    const rangeArray = [...tableData];
                    // Generate numbers from start to end
                    for (let i = start; i <= end; i++) {
                        if (i <= 20 || i % 2 === 0) {
                            // rangeArray.push(i);
                            rangeArray.push({
                                size: i,
                                qty: '0',
                                rate: '0',
                                color: color,
                                shadeNo: shadeNo,
                                barcode: barcode++
                            });
                        }
                    }

                    // Ensure the end number is included if odd
                    if (end > 20 && end % 2 !== 0 && !rangeArray.includes(end)) {
                        // rangeArray.push(end);
                        rangeArray.push({
                            size: end,
                            qty: '0',
                            rate: '0',
                            color: color,
                            shadeNo: shadeNo,
                            barcode: barcode++
                        });
                    }

                    // Add the generated range to the numbers list
                    // setNumbers([...numbers, ...rangeArray]);

                    setTableData(rangeArray);
                }
            }
            else if (match2) {
                alert(`Complete the Sizes Value ${number}`);
            } else {
                // If the input doesn't match the range format, add the string directly to the numbers list
                // setNumbers([...numbers, number]);
                const update = {
                    size: number,
                    qty: '0',
                    rate: '0',
                    color: color,
                    shadeNo: shadeNo,
                    barcode: barcode++
                };
                setTableData([...tableData, update]);
            }

            // ✅ Update barcode tracker
            setCurrentBarcode(barcode);

            setNumber('');  // Clear the input field after processing
        }
    };

    const handleSelectRow = (index) => {
        setSelectedRows(prevSelectedRows => {
            if (prevSelectedRows.includes(index)) {
                return prevSelectedRows.filter(rowIndex => rowIndex !== index);
            } else {
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleChange = (index, field, value) => {
        // Create a copy of the tableData to avoid direct mutation
        const updatedData = [...tableData];
        // Update the specific field for the item at the given index
        updatedData[index] = {
            ...updatedData[index],
            [field]: value, // Dynamically update the field
        };

        // Set the updated tableData
        setTableData(updatedData);
    };

    const handleDeleteSelected = () => {
        const filteredNumbers = tableData.filter((_, index) => !selectedRows.includes(index));
        setTableData(filteredNumbers);
        setSelectedRows([]); // Clear selection after delete
    };

    const validateInput = (value) => {
        // Regular expression for validating simple numbers (e.g., 22, 45)
        const validNumberPattern = /^\d+$/;

        // Regular expression for validating the allowed range formats (e.g., 20-30, 20/30, 20X30, or 20x30)
        const validRangePattern = /^\d+[-/Xx]\d+$/;

        // Check if the input is a valid number or a valid range format
        if (!validNumberPattern.test(value) && !validRangePattern.test(value)) {
            setErrors({ sizes: 'Invalid input format. Please use the format like 20-30, 20/30, 20X30, or just a number like 22.' });
            return false;
        }

        setErrors({ sizes: '' });  // Clear any errors if input is valid
        return true;
    };

    const handleChange2 = (e) => {
        const value = e.target.value;

        // Allow only numbers and valid characters (hyphen, slash, X, x)
        const restrictedPattern = /^[0-9]+[-/Xx]?[0-9]*$/;  // This pattern allows numbers with optional valid separator

        // Check if the value matches the allowed restricted pattern or is an empty string
        if (restrictedPattern.test(value) || value === '') {
            setNumber(value);
            // Validate input on each change
            validateInput(value);
        }
    };

    const handleNavitoItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // setPreviousPath(window.location.pathname);
        // navigate('/NewItemEntry');
    };

    const handleNavitoCloth = () => {
        window.open(`/NewClothEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
        // setPreviousPath(window.location.pathname);
        // navigate('/NewClothEntry');
    };

    const validate = () => {
        const newErrors = {};
        if (!formData.itemId) newErrors.itemId = 'Item is required';
        if (!formData.clothId) newErrors.clothId = 'Cloth is required';
        if (!formData.rack) newErrors.rack = 'Rack is required';
        return newErrors;
    };

    function object(formData, multipleItems) {

        const data = {
            dt: formData.dt,
            bailno: formData.bailno,
            userId: formData.userId,
            multiItems: multipleItems
        };
        return data;
    };

    const handleAddDataforMultipleItems = (tableData, formData) => {
        if (formData.locId.trim() === "") {
            alert("Please Select Location");
            return;
        }

        if (formData.rack.trim() === "") {
            alert("Please Select Rack");
            return;
        }
        const getItemName = (itemList, itemId) => itemList?.data?.find(item => item.ID === itemId)?.itemNm || '';
        const getIcode = (itemList, itemId) => itemList?.data?.find(item => item.ID === itemId)?.icode || '';
        const getClothName = (clothdata, id) => {
            const cloth = clothdata?.find(item => item.ID === id);
            return cloth ? `${cloth.clothNm} ${cloth.model} ${cloth.color} ${cloth.shadeNo} ${cloth.panna_size}` : ''
        };
        const locNm = locData?.data?.find(item => item.ID === formData.locId)?.locNm;

        const clothdatas = clothlist?.data;
        const data = {
            itemId: formData.itemId,
            clothId: formData.clothId,
            m1cloth: formData.m1cloth,
            m2cloth: formData.m2cloth,
            m3cloth: formData.m3cloth,
            mclothNm: getClothName(clothdatas, formData.clothId),
            m1clothNm: getClothName(clothdatas, formData.m1cloth),
            m2clothNm: getClothName(clothdatas, formData.m2cloth),
            m3clothNm: getClothName(clothdatas, formData.m3cloth),
            rack: formData.rack,
            locNm: locNm,
            locId: formData.locId,
            itemNm: getItemName(itemList, formData.itemId),
            icode: getIcode(itemList, formData.itemId),
            tableData: tableData
        };
        setMultipleItems(prev => [...prev, data]);

        setTableData([]);
        setFormData(prev => ({
            ...prev,
            itemId: '',
            clothId: '',
            m1cloth: '',
            m2cloth: '',
            m3cloth: '',
            rack: '',
            locId: '',
            color: '',
            shadeNo: ''
        }));
    };

    // console.log(multipleItems);

    const dropdownConfig = [
        {
            label: "Item",
            id: "itemId",
            options: itemList.data,
            value: formData.itemId,
            onChange: (event, newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId'),
            getOptionLabel: (option) => option.itemNm || "",
            error: errors.itemId,
            helperText: errors.itemId,
            showNewButton: true,
            handleNewButton: handleNavitoItem,
        },
        {
            label: "Cloth",
            id: "clothId",
            options: clothlist.data,
            value: formData.clothId,
            onChange: (event, newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId'),
            getOptionLabel: (option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`,
            error: errors.clothId,
            helperText: errors.clothId,
            showNewButton: true,
            handleNewButton: handleNavitoCloth,
        },
        {
            label: "Rack",
            id: "rack",
            options: rackList.data,
            value: formData.rack,
            onChange: (event, newValue) => handleDropdownChange({ target: { name: 'rack', value: newValue ? newValue.rackNm : '' } }, 'rack'),
            getOptionLabel: (option) => option.rackNm || "",
            error: errors.rack,
            helperText: errors.rack,
            showNewButton: false,
            handleNewButton: null,
        },
    ];

    // console.log(multipleItems)

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        setLoading(true);
        try {
            const postData = object(formData, multipleItems);
            // console.log(postData)

            const result = await dispatch(insertManualStkEntry(postData)).unwrap();
            console.log('POST request successful!', result);
            // alert("Stock Added");
            // window.location.reload();
            const data = result;
            if (data?.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                if (Array.isArray(data?.msg)) {
                    alert(data.msg.join("\n"));
                } else if (typeof data?.msg === "string") {
                    alert(data.msg);
                }
            }
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }


    };


    const handleViewClick = (form) => {
        // Construct the URL with query parameters or use a placeholder route
        const url = `/Manuall-Stock-item-view?form=${encodeURIComponent(JSON.stringify(form))}`;

        // Open the URL in a new tab
        window.open(url, '_blank', 'width=1000,height=600,scrollbars=yes,resizable=yes');
    };

    const handleDeleteItem = (indexToDelete) => {
        // const updatedItems = multipleItems.filter((_, index) => index !== indexToDelete);
        // setMultipleItems(updatedItems);
        // console.log(multipleItems);
        const deleteItems = multipleItems.find((_, index) => index === indexToDelete);
        var selectbarcode = deleteItems?.tableData?.length > 0 && deleteItems?.tableData[0]?.barcode;
        // console.log('deleteItems', selectbarcode);
        const nextindx = indexToDelete + 1;

        const beforeItemForbarcode = multipleItems?.filter((_, index) => index < indexToDelete);
        const updatedItemsForbarcode = multipleItems?.filter((_, index) => index >= nextindx);
        const operationData = updatedItemsForbarcode?.map((item, index) => {
            const nextBrcode = selectbarcode;
            const data = assignBarcodes(nextBrcode, item.tableData);
            selectbarcode = nextBrcode + item.tableData?.length;
            return {
                ...item,
                tableData: data
            };
        });

        const resultArr = [...beforeItemForbarcode, ...operationData];
        // console.log('result', resultArr,selectbarcode);
        // setMultipleItems(prevItems => prevItems.filter((_, index) => index !== indexToDelete));
        setMultipleItems(resultArr);
        setCurrentBarcode(selectbarcode);
    };

    function assignBarcodes(barcnt, arr) {
        const updatedArr = arr.map((item, index) => {
            return {
                ...item,
                barcode: barcnt + index
            };
        });

        const finalBarcnt = barcnt + arr.length;

        // return {
        //     updatedArray: updatedArr,
        //     finalBarcnt: finalBarcnt
        // };
        return updatedArr;
    }


    const dropdownlistfirst = [
        {
            label: 'Location',
            id: 'locId',
            options: locData?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    return (
        <>
            <Titlebar data={props?.data?.menu} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>{props?.data?.title}</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>
                                {[
                                    { label: 'Date', name: 'dt', type: 'date' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name]}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: true }}
                                                            sx={inputStyles}
                                                        />
                                                    )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="itemId">Item:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="itemId"
                                                    name="itemId"
                                                    options={itemList.data}
                                                    getOptionLabel={(option) => option.itemNm || ""}
                                                    value={itemList.data.find(item => item.ID === formData.itemId) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'itemId', value: newValue ? newValue.ID : '' } }, 'itemId')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            error={!!errors.itemId}
                                                            helperText={errors.itemId}
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoItem} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="clothId">Main Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="clothId"
                                                    name="clothId"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={clothlist?.data?.find(item => item.ID === formData.clothId) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'clothId', value: newValue ? newValue.ID : '' } }, 'clothId')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.clothId}
                                                            helperText={errors.clothId}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoCloth} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    {/* {m1clothdata.length > 0 && */}
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="m1cloth">Matching 1 Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="m1cloth"
                                                    name="m1cloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={clothlist?.data?.find(item => item.ID === formData.m1cloth) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'm1cloth', value: newValue ? newValue.ID : '' } }, 'm1cloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.m1cloth}
                                                            helperText={errors.m1cloth}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoCloth} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    {/* } */}
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    {/* {m2clothdata.length > 0 && */}
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="m2cloth">Matching 2 Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="m2cloth"
                                                    name="m2cloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={clothlist?.data?.find(item => item.ID === formData.m2cloth) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'm2cloth', value: newValue ? newValue.ID : '' } }, 'm2cloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.m2cloth}
                                                            helperText={errors.m2cloth}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoCloth} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    {/* } */}
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    {/* {m3clothdata.length > 0 && */}
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="m3cloth">Matching 3 Cloth:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="m3cloth"
                                                    name="m3cloth"
                                                    options={clothlist?.data}
                                                    getOptionLabel={(option) => `${option.clothNm} ${option.model} ${option.color} ${option.shadeNo} ${option.panna_size}`}
                                                    value={clothlist?.data?.find(item => item.ID === formData.m3cloth) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'm3cloth', value: newValue ? newValue.ID : '' } }, 'm3cloth')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.m3cloth}
                                                            helperText={errors.m3cloth}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button onClick={handleNavitoCloth} variant="contained" size="small">
                                                New
                                            </Button>
                                        </Grid>
                                    </Grid>
                                    {/* } */}
                                </Grid>


                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="rack">Rack:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Autocomplete
                                                    id="rack"
                                                    name="rack"
                                                    options={rackList.data}
                                                    getOptionLabel={(option) => option.rackNm || ""}
                                                    value={rackList.data.find(item => item.rackNm === formData.rack) || null}
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'rack', value: newValue ? newValue.rackNm : '' } }, 'rack')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            placeholder="Select an option"
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                            error={!!errors.rack}
                                                            helperText={errors.rack}
                                                        />
                                                    )}
                                                />
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>


                                {
                                    dropdownlistfirst && dropdownlistfirst.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }



                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel htmlFor='number'>Sizes:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <TextField
                                                    type='text'
                                                    id='number'
                                                    name='number'
                                                    value={number}
                                                    onChange={handleChange2}
                                                    inputProps={{ style: styled.input }}
                                                    sx={inputStyles}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs>
                                            <Button variant="contained" color="primary" onClick={handleAddNumber} size='small' disabled={number === ""}>Add</Button>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'Bail No.', name: 'bailno' },
                                    {/* { label: 'Color', name: 'color' },
                                    { label: 'ShadeNo', name: 'shadeNo' }, */}
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name} >{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>

                                                    <TextField
                                                        id={field.name}
                                                        name={field.name}
                                                        value={formData[field.name]}
                                                        onChange={handleInputChange}
                                                        inputProps={{ style: styled.input }}
                                                        sx={inputStyles}
                                                    />

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                <Grid item xs={12} md={12}>
                                    <Typography
                                        variant="body1" // or any other variant you prefer
                                        color="error" // This uses the default error color which is red in MUI
                                        sx={{
                                            color: 'red', // Directly set the color if you want a specific shade
                                            fontWeight: 'bold', // Optional: Make the text bold
                                        }}
                                    >
                                        If Range for Example: 20-30 <br />
                                        If Enter Size with Width then use ' / ' or ' X | x '
                                    </Typography>
                                </Grid>





                                {tableData?.length > 0 &&

                                    <>

                                        <Grid item xs={12} md={12}>
                                            <Button
                                                onClick={handleDeleteSelected}
                                                disabled={selectedRows.length === 0}
                                                variant="contained"
                                                color="error"
                                            >
                                                Delete
                                            </Button>

                                        </Grid>
                                        <Grid item xs={12} md={10}>
                                            <TableContainer style={{
                                                width: isDesktop ? '100%' : '100%',
                                                // marginLeft: isDesktop ? '20%' : '0%',
                                                overflowX: 'hidden'
                                            }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Select</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>SrNo</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Barcode</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Size</TableCell>
                                                            {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Color</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Shade No.</TableCell> */}
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Qty</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Rate</TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {Array.isArray(tableData) && tableData?.map((item, index) => (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <Checkbox
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleSelectRow(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.barcode}</TableCell>

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    {/* <TextField
                                                                type="text"
                                                                value={item.size}
                                                                onChange={(e) => handleChange(index, 'size', e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbersmall}
                                                            /> */}
                                                                    <input
                                                                        type="text"
                                                                        name='size'
                                                                        value={item.size}
                                                                        onChange={(e) => handleChange(index, 'size', e.target.value)}
                                                                        style={{
                                                                            outline: 'none',
                                                                            width: '50px',
                                                                            padding: '2px'
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        name='color'
                                                                        value={item.color}
                                                                        onChange={(e) => handleChange(index, 'color', e.target.value)}
                                                                        style={{
                                                                            outline: 'none',
                                                                            width: '100px',
                                                                            padding: '2px'
                                                                        }}
                                                                    />
                                                                </TableCell> */}

                                                                {/* <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        name='shadeNo'
                                                                        value={item.shadeNo}
                                                                        onChange={(e) => handleChange(index, 'shadeNo', e.target.value)}
                                                                        style={{
                                                                            outline: 'none',
                                                                            width: '100px',
                                                                            padding: '2px'
                                                                        }}
                                                                    />
                                                                </TableCell> */}

                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    {/* <TextField
                                                                type="text"
                                                                value={item.qty}
                                                                onChange={(e) => handleChange(index, 'qty', e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbersmall}
                                                            /> */}

                                                                    <input
                                                                        type="text"
                                                                        name='qty'
                                                                        value={item.qty}
                                                                        onChange={(e) => handleChange(index, 'qty', e.target.value)}
                                                                        style={{
                                                                            outline: 'none',
                                                                            width: '50px',
                                                                            padding: '2px'
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                    {/* <TextField
                                                                type="text"
                                                                value={item.rate}
                                                                onChange={(e) => handleChange(index, 'rate', e.target.value)}
                                                                inputProps={{ style: styled.inputs }}
                                                                sx={inputNumbersmall}
                                                            /> */}

                                                                    <input
                                                                        type="text"
                                                                        name='rate'
                                                                        value={item.rate}
                                                                        onChange={(e) => handleChange(index, 'rate', e.target.value)}
                                                                        style={{
                                                                            outline: 'none',
                                                                            width: '50px',
                                                                            padding: '2px'
                                                                        }}
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>



                                            <Grid item xs={12} textAlign="center">
                                                <Button variant="contained" color="primary" onClick={() => handleAddDataforMultipleItems(tableData, formData)}>Add</Button>
                                            </Grid>
                                        </Grid>
                                    </>
                                }


                                {multipleItems?.length > 0 &&
                                    <Grid item xs={12} md={10}>
                                        <TableContainer style={{
                                            width: isDesktop ? '100%' : '100%',
                                            // marginLeft: isDesktop ? '20%' : '0%',
                                            overflowX: 'hidden'
                                        }}>
                                            <Table>
                                                <TableHead>
                                                    <TableRow className='tbl-row'>

                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>SrNo</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Item</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>View</TableCell>
                                                        <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>Delete</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {Array.isArray(multipleItems) && multipleItems?.map((item, index) => (
                                                        <TableRow key={index}>

                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{index + 1}</TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.itemNm}</TableCell>

                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <Preview className='cursor-pointer' onClick={() => handleViewClick(item)} />
                                                            </TableCell>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center'>
                                                                <DeleteIcon className='cursor-pointer' onClick={() => handleDeleteItem(index)} />
                                                            </TableCell>


                                                        </TableRow>
                                                    ))}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <Grid item xs={12} textAlign="center">
                                            <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                                {
                                                    loading === true ?
                                                        <><CircularProgress size="20px" /> wait...</> :
                                                        "Submit"
                                                }
                                            </Button>
                                        </Grid>

                                    </Grid>}



                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default StkManuallyEntry2;
